import { useEffect, useState } from "react";
import { Trans, useTranslation, getI18n } from "react-i18next";
import { RandomReveal } from "react-random-reveal";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { ProfilePicImage } from "./global";
import LanguageSetter from "./LanguageSetter";
import NavigationButton from "./NavigationButton";

const DescriptionSpan = styled.span`
    font-family: monospace;
    font-size: 2.2rem;
    color: #F4722B;
    display: inline-block;
    text-align: center;
    font-weight: 600;
`
const LanguagePicker = styled.div`
    font-size: small;
`

function Description(props: { descriptionList: string[], override: boolean }) {
    useTranslation();
    const [descriptionIndex, setDescriptionIndex] = useState(0);

    function generateDescription() {
        setDescriptionIndex(prev => {
            const next = (prev + 1) % props.descriptionList.length
            return next;
        });
    }

    if (props.override) {
        return <DescriptionSpan><RandomReveal
            isPlaying
            duration={1}
            revealDuration={0}
            revealEasing='easeOutQuad'
            characters={[props.descriptionList[descriptionIndex].slice(0, 2)]}
            characterSet={['🧬', '💻', '🐺', '🏳️‍🌈', '🦊', '🍆', '🐦', '🐾', '🦦', '🐈', '📈', '⚡', '🎨', '🐰', '🧷']}
            onComplete={() => {
                return {
                    shouldRepeat: true,
                    delay: 0
                }
            }}></RandomReveal>
            <RandomReveal
                isPlaying
                duration={1}
                revealDuration={0}
                revealEasing='easeOutQuad'
                characters={props.descriptionList[descriptionIndex].slice(2)}
                characterSet={['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                onComplete={() => {
                    generateDescription();
                    return {
                        shouldRepeat: true,
                        delay: 0
                    }
                }}></RandomReveal>
        </DescriptionSpan>
    }

    return (
        <DescriptionSpan>
            <RandomReveal
                isPlaying
                duration={1.1}
                revealDuration={0}
                revealEasing='easeOutQuad'
                characters={[props.descriptionList[descriptionIndex].slice(0, 2)]}
                characterSet={['🧬', '💻', '🐺', '🏳️‍🌈', '🦊', '🍆', '🐦', '🐾', '🦦', '🐈', '📈', '⚡', '🎨', '🐰', '🧷']}
                onComplete={() => {
                    return {
                        shouldRepeat: true,
                        delay: 3
                    }
                }}></RandomReveal>

            <RandomReveal
                isPlaying
                duration={1.1}
                revealDuration={0}
                revealEasing='easeOutQuad'
                characters={props.descriptionList[descriptionIndex].slice(2)}
                characterSet={['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                onComplete={() => {
                    generateDescription();
                    return {
                        shouldRepeat: true,
                        delay: 3
                    }
                }}></RandomReveal>
        </DescriptionSpan>)
}
const LandingPageMain = styled.main`
        width: 100vw;
        height: 100vh;
        display: flex;
        gap: 1em;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #F6E7C1;
        text-align: center;
    `;

const AdditionalText = styled.div`
    display: inline-flex;
    align-items: flex-end;
    font-size: 1.5rem;
    height: 2em;
`

const PrimaryText = styled.h1`
    font-weight: 400;
`

export default function LandingPage() {
    const { t } = useTranslation();
    const [overrideScrambling, setHideScrambling] = useState(false);
    const langChangeCallback = () => {
        setHideScrambling(true);
        setTimeout(() => setHideScrambling(false), 1100);
    }
    return <>
        <LandingPageMain>
            <Link to="/"><ProfilePicImage src="https://i.imgur.com/oa8fgaa.png" size={16} /></Link>
            <AdditionalText><Trans i18nKey="landing.welcome">Hi! I'm KiraaCorsac, also known as Filip Opálený.</Trans></AdditionalText>
            <PrimaryText><Trans i18nKey="landing.im">I'm a</Trans> <Description descriptionList={[
                t("landing.threed"),
                t("landing.programming"),
                t("landing.bioviz")
            ]}
                override={overrideScrambling} /> <Trans i18nKey="landing.other">and many other things.</Trans></PrimaryText>
            <AdditionalText><Trans i18nKey="landing.click">Click to learn more about</Trans>: <NavigationButton to="/digital-3d-artist">🦊</NavigationButton><NavigationButton to="/programming-tutor">💻</NavigationButton><NavigationButton to="/bioviz-researcher">🧬</NavigationButton></AdditionalText>

            <LanguagePicker>
                <Trans i18nKey="landing.language">Language</Trans>: <LanguageSetter name="en" label="English" callback={langChangeCallback} /> | <LanguageSetter name="sk" label="Slovensky" callback={langChangeCallback} /> | <LanguageSetter name="cz" label="Česky" callback={langChangeCallback} />
            </LanguagePicker>
        </LandingPageMain >
    </>;
}
